// extracted by mini-css-extract-plugin
export default {"anchor":"PayoutRequisites_anchor__Voe1r","more":"PayoutRequisites_more__IYq2Y","panel":"PayoutRequisites_panel__8i8S8","divided":"PayoutRequisites_divided__o5PYj"};